<template>
  <div></div>
</template>
<script>
import common from "../../common/js/common";
import EventHandler from "../../common/js/EventHandler";
export default {
  data() {
    return {};
  },
  created() {
    let userId = common.getUrlParam2("userId");
    let ocId = common.getUrlParam2("ocId");
    this.getActivity(userId, ocId);
  },
  methods: {
    getActivity: function(userId, ocId) {
      var that = this;
      that.$http
        .get(
          this.baseURL + "/appscreen/PCStartScreen/" + userId + "?ocId=" + ocId
        )
        .then(res => {
          if (res.data.activityId) {
            common.setCookie("userId", res.data.userId, 30);
            common.setCookie("activityId", res.data.activityId, 30);
            common.setCookie("type", res.data.type, 30);
            common.setCookie("screenKey", res.data.screenKey, 30);
            common.setCookie("ocId", res.data.ocId, 30);
            common.setCookie("channel", res.data.channel, 30);
            common.setCookie("Authorization", res.data.Authorization, 30);
            setTimeout(function() {
              that.initLongConnection();
            });
            switch (res.data.type) {
              case 1:
                this.$router.replace({ path: "/screenIndex/signIn" });
                break;
              case 2:
                this.$router.replace({ path: "/screenIndex/vote" });
                break;
              case 3:
                this.$router.replace({ path: "/screenIndex/responder" });
                break;
              case 4:
                this.$router.replace({ path: "/screenIndex/discuss" });
                break;
              case 5:
                this.$router.replace({ path: "/screenIndex/pick" });
                break;
              case 6:
                this.$router.replace({ path: "/screenIndex/score" });
                break;
              case 7:
                this.$router.replace({ path: "/screenIndex/resource" });
                break;
            }
          } else {
            common.setCookie("userId", res.data.userId, 30);
            common.setCookie("Authorization", res.data.Authorization, 30);
            common.setCookie("channel", res.data.channel, 30);
            if (res.data.ocId) {
              common.setCookie("ocId", res.data.ocId, 30);
            }
            setTimeout(function() {
              that.initLongConnection();
            });
            this.$router.replace({ path: "/loadingIn" });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/screenCenter/screenCenter.vue